export default __webpack_public_path__ + "static/media/fallback-icon.a043986f.svg";